import { render, staticRenderFns } from "./stages.vue?vue&type=template&id=7cfd760c&scoped=true&"
import script from "./stages.vue?vue&type=script&lang=js&"
export * from "./stages.vue?vue&type=script&lang=js&"
import style0 from "./stages.vue?vue&type=style&index=0&id=7cfd760c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfd760c",
  null
  
)

export default component.exports